'use strict';

var d3 = require('d3');
var chartParams = require('./Params');
var chartScales = require('./Scales');
var PricingBarChart = function PricingBarChart(AbstractChart, chartGroups, chartSimpleBars, chartCircles, chartXAxis, chartYAxis, chartConstants) {
  var Chart = function Chart(container, formatters) {
    AbstractChart.call(this, container);
    var groups = chartGroups('label', formatters.tooltipFormatter, true);
    var fareChangeBars = chartSimpleBars('fareChange');
    var circles = chartCircles('circles');
    var dispatch = d3.dispatch('selectedBar');
    d3.rebind(this, dispatch, 'on');
    this.padding = {
      top: 30,
      bottom: 60,
      left: 75,
      right: 75
    };
    this.render = function (data, selectedMetric, chartWidth) {
      if (selectedMetric === undefined) {
        return;
      }
      data = data || this.data;
      var length = data.length;
      var xAxis = chartXAxis(formatters.xAxisTickFormatter).withTextRotation(chartConstants.AXIS.SKEW.DEG_30).withRepetition(1);
      var leftYAxis = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT).label('Services').withoutHorizontalLines();
      var rightYAxis = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.RIGHT).label(selectedMetric.chartLabel).withLabelRotation(-90).withoutHorizontalLines();
      this.initChart(data, [0, length], chartParams(this.padding, chartWidth));
      this.scalesLeft = chartScales(this.params, this.data, 'label', 'numberOfEffectedServices', 'numberOfExcludedServices');
      this.scalesRight = chartScales(this.params, this.data, 'label', 'fareChange');
      this.callForDataGroup([groups, fareChangeBars, xAxis, rightYAxis], this.scalesRight);
      this.callForDataGroup([circles, leftYAxis], this.scalesLeft);
    };
    groups.on('groupclick', function (d, i) {
      dispatch.selectedBar(d, i);
    });
    container.on('$destroy', function () {
      groups.on('groupclick', null);
    });
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
PricingBarChart.$inject = ['AbstractChart', 'ChartElementsGroup', 'ChartElementsSimpleBars', 'ChartElementsCircles', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsConstants'];
module.exports = PricingBarChart;